const organization_details = {
    departments: {
        leader: 'Responsável',
        leaders: 'Responsáveis do departamento',
        led_departments: 'Departamentos sob sua gestão',
        edit_leaders: 'Gerenciar responsáveis',
        add_leader: 'Adicionar',
        remove_leader: 'Remover',
        no_leaders: 'Sem responsáveis',
        local: 'Gestão local',
        managed_members: 'Membros no âmbito de gestão',
        leader_scope_hint: 'Gerencie as atribuições dos seus departamentos e subdepartamentos.',
        leader_permission_hint: 'Responsáveis gerenciam as atribuições dos seus departamentos e subdepartamentos, sem alterar funções ou hierarquias.',
        primary_synced: 'O departamento principal é gerenciado pelo Feishu.',
        status_active: 'Ativo',
        status_suspended: 'Suspenso',
        status_departed: 'Desligado',
        status_pending: 'Ativação pendente',
        search: 'Pesquisar',
        previous_page: 'Página anterior',
        next_page: 'Página seguinte',
        directory_title: 'Membros da organização',
        member_name: 'Membro',
        search_members: 'Pesquisar por nome ou utilizador',
        include_descendants: 'Incluir subdepartamentos',
        no_members: 'Nenhum membro encontrado.',
        all_members: 'Todos os membros',
        all_departments: 'Todos os departamentos',
        edit_member: 'Editar departamentos',
        add_child: 'Adicionar subdepartamento',
        expand_department: 'Expandir {{name}}',
        collapse_department: 'Recolher {{name}}',
        title: 'Departamentos',
        description: 'Gira os departamentos e as associações dos membros desta organização.',
        create: 'Criar departamento',
        edit: 'Editar departamento',
        name: 'Nome do departamento',
        parent: 'Departamento superior',
        root: 'Sem departamento superior',
        id: 'ID do departamento',
        members: 'Departamentos dos membros',
        member_id: 'ID de utilizador do membro',
        primary: 'Departamento principal',
        none: 'Não definido',
        assignments: 'Associações a departamentos',
        no_assignments: 'Ainda não existem associações a departamentos.',
        assignment_hint: 'Atribua departamentos locais e, opcionalmente, um principal. As associações do diretório são só de leitura.',
        empty: 'Ainda não existem departamentos.',
        readonly: 'Pode ver os departamentos e as suas associações. Contacte um administrador para fazer alterações.',
        load_error: 'Não foi possível carregar os dados. Tente novamente.',
        mutation_error: 'Não foi possível guardar. Verifique permissões, associação e hierarquia dos departamentos.',
        loading: 'A carregar…',
        synced: 'Gerido pelo diretório',
        choose: 'Pesquisar departamentos',
        organizations_title: 'Organizações e departamentos',
        organizations_description: 'Escolha uma organização para ver ou gerir os seus departamentos.',
        no_organizations: 'Não pertence a nenhuma organização. Contacte um administrador.',
        organization: 'Organização atual',
        choose_organization: 'Escolha uma organização',
        delete_title: 'Eliminar departamento',
        delete_description: 'Eliminar «{{name}}»? Mova primeiro os membros e subdepartamentos.',
    },
    directory: {
        leaders_label: 'Responsabilidades do departamento',
        local_department_leader: 'Responsável atribuído localmente',
        status_active: 'Ativo',
        status_suspended: 'Suspenso',
        status_departed: 'Desligado',
        status_pending: 'Ativação pendente',
        profiles_label: 'Perfis de origem',
        primary_label: 'Alterações de departamento principal',
        deactivated_label: 'Identidades desativadas',
        reactivated_label: 'Identidades reativadas',
        lifecycle_notice: 'Atribuições de funções mantidas: {{count}}. A reativação restaura as permissões anteriores.',
        title: 'Diretório Feishu',
        description: 'Importe departamentos e membros para esta organização através de um conector Feishu.',
        identity_notice: 'Use um conector com aprovisionamento de diretório ativo. Alterar a identidade de um conector existente requer a migração de contas.',
        connector: 'ID do conector Feishu',
        preview: 'Pré-visualizar sincronização',
        preview_title: 'Pré-visualização da sincronização',
        preview_description: 'Reveja o diretório antes de importar. Se houver alterações, gere uma nova pré-visualização.',
        import: 'Confirmar sincronização',
        success: '{{departments}} departamentos e {{users}} membros importados; {{createdUsers}} contas criadas. Removidos {{removedDepartments}} departamentos, {{removedMemberships}} associações e {{removedAssignments}} atribuições.',
        failure: 'Não foi possível ler ou importar o diretório. Verifique as permissões e a visibilidade e volte a pré-visualizar.',
        behavior_title: 'Modo de importação',
        mode: 'Sincronizar nomes, avatares, departamentos e departamentos principais. Membros ausentes ou inativos perdem acesso somente a esta organização; funções, atribuições locais, contas globais e outras identidades são mantidas. E-mail e telefone são dados de origem, não credenciais de acesso.',
        limits: 'Por importação: 1000 departamentos, 5000 utilizadores, 10000 associações; leitura limitada a 60 segundos. Importações incompletas ou excessivas são rejeitadas.',
        counts: '{{departments}} departamentos · {{users}} membros',
        departments_label: 'Departamentos',
        members_label: 'Associações à organização',
        assignments_label: 'Atribuições a departamentos',
        item: 'Item',
        added: 'Adicionar',
        updated: 'Atualizar',
        removed: 'Remover',
        cleanup_notice: 'Sincronizar nomes, avatares, departamentos e departamentos principais. Membros ausentes ou inativos perdem acesso somente a esta organização; funções, atribuições locais, contas globais e outras identidades são mantidas. E-mail e telefone são dados de origem, não credenciais de acesso.',
        conflicts_title: '{{count}} conflitos bloqueiam a sincronização. Resolva as dependências locais e volte a pré-visualizar.',
        removals_title: 'Exemplos de remoção (até 20 por categoria)',
        local_child_department: 'Subdepartamento local',
        unowned_assignment: 'Atribuição local ou antiga sem origem comprovada',
        local_member_roles: 'O membro tem funções atribuídas localmente',
        unlinked_identity: 'A identidade do diretório foi desligada',
    },
    page_title: 'Detalhes da organização',
    delete_confirmation: 'Uma vez eliminada, todos os membros perderão a sua adesão e funções nesta organização. Esta ação não pode ser desfeita.',
    organization_id: 'ID da organização',
    settings_description: 'As organizações representam as equipas, clientes empresariais e empresas parceiras que podem aceder às suas aplicações.',
    name_placeholder: 'O nome da organização, não é necessário ser único.',
    description_placeholder: 'Uma descrição da organização.',
    member: 'Membro',
    member_other: 'Membros',
    add_members_to_organization: 'Adicionar membros à organização {{name}}',
    add_members_to_organization_description: 'Encontre utilizadores adequados pesquisando por nome, email, telefone ou ID de utilizador. Os membros existentes não são mostrados nos resultados da pesquisa.',
    add_with_organization_role: 'Adicionar com função(ões) de organização',
    user: 'Utilizador',
    application: 'Aplicação',
    application_other: 'Aplicações',
    add_applications_to_organization: 'Adicionar aplicações à organização {{name}}',
    add_applications_to_organization_description: 'Encontre aplicações adequadas pesquisando pelo ID da aplicação, nome ou descrição. As aplicações existentes não são mostradas nos resultados da pesquisa.',
    at_least_one_application: 'É necessária pelo menos uma aplicação.',
    remove_application_from_organization: 'Remover aplicação da organização',
    remove_application_from_organization_description: 'Uma vez removida, a aplicação perderá a sua associação e funções nesta organização. Esta ação não pode ser desfeita.',
    search_application_placeholder: 'Pesquisar pelo ID da aplicação, nome ou descrição',
    roles: 'Funções da organização',
    authorize_to_roles: 'Autorizar {{name}} a aceder às seguintes funções:',
    edit_organization_roles: 'Editar funções da organização',
    edit_organization_roles_title: 'Editar funções da organização de {{name}}',
    remove_user_from_organization: 'Remover utilizador da organização',
    remove_user_from_organization_description: 'Uma vez removido, o utilizador perderá a sua adesão e funções nesta organização. Esta ação não pode ser desfeita.',
    search_user_placeholder: 'Pesquisar por nome, email, telefone ou ID de utilizador',
    at_least_one_user: 'Pelo menos um utilizador é necessário.',
    organization_roles_tooltip: 'As funções atribuídas ao {{type}} dentro desta organização.',
    custom_data: 'Dados personalizados',
    custom_data_tip: 'Dados personalizados é um objeto JSON que pode ser usado para armazenar dados adicionais associados à organização.',
    invalid_json_object: 'Objeto JSON inválido.',
    branding: {
        name: 'Marca',
        description: 'Personalize a experiência de início de sessão ao nível da organização.',
        organization_level_sie: 'Experiência de início de sessão ao nível da organização',
        organization_level_sie_switch: 'Ative a experiência de início de sessão ao nível da organização e configure a marca específica. Se desativado, recua primeiro para a experiência ao nível da aplicação e depois para a experiência omni.',
        logo: 'Logos da organização',
        logo_tooltip: 'Pode passar o ID da organização para exibir este logo na experiência de login; a versão escura do logo é necessária se o modo escuro estiver ativado nas configurações da experiência de login omni. <a>Saiba mais</a>',
    },
    jit: {
        title: 'Provisionamento just-in-time',
        description: 'Os utilizadores podem juntar-se automaticamente à organização e receber funções na sua primeira entrada através de alguns métodos de autenticação. Pode definir requisitos para o provisionamento just-in-time.',
        email_domain: 'Provisionamento de domínio de email',
        email_domain_description: 'Novos utilizadores que se inscrevam com os seus endereços de email verificados ou através do login social com endereços de email verificados juntar-se-ão automaticamente à organização. <a>Saiba mais</a>',
        email_domain_placeholder: 'Introduza domínios de email para provisionamento just-in-time',
        invalid_domain: 'Domínio inválido',
        domain_already_added: 'Domínio já adicionado',
        sso_enabled_domain_warning: 'Introduziu um ou mais domínios de email associados ao SSO empresarial. Os utilizadores com estes emails seguirão o fluxo padrão de SSO e não serão provisionados para esta organização a menos que o provisionamento de SSO empresarial esteja configurado.',
        enterprise_sso: 'Provisionamento de SSO empresarial',
        no_enterprise_connector_set: 'Ainda não configurou nenhum conector de SSO empresarial. Adicione conectores primeiro para ativar o provisionamento de SSO empresarial. <a>Configurar</a>',
        add_enterprise_connector: 'Adicionar conector empresarial',
        enterprise_sso_description: 'Novos utilizadores ou utilizadores existentes que iniciem sessão através do SSO empresarial pela primeira vez juntar-se-ão automaticamente à organização. <a>Saiba mais</a>',
        organization_roles: 'Funções padrão da organização',
        organization_roles_description: 'Atribuir funções aos utilizadores ao juntarem-se à organização através do provisionamento just-in-time.',
    },
    mfa: {
        title: 'Autenticação de múltiplos fatores (MFA)',
        tip: 'Quando a MFA é necessária, os utilizadores sem MFA configurado serão recusados ao tentar trocar um token da organização. Esta configuração não afeta a autenticação do utilizador.',
        description: 'Exigir que os utilizadores configurem a autenticação de múltiplos fatores para aceder a esta organização.',
        no_mfa_warning: 'Nenhum método de autenticação de múltiplos fatores está habilitado para o seu inquilino. Os utilizadores não poderão aceder a esta organização até que pelo menos um <a>método de autenticação de múltiplos fatores</a> seja habilitado.',
    },
};
export default Object.freeze(organization_details);
